import colors from "common/constants/colorsOld";
import type { ReactElement, ReactNode } from "react";
import HorizontalRule from "ui/components/HorizontalRule";
import Link from "ui/components/Link";
import cx from "ui/cx";
import IconLineArrow from "ui/icons/IconLineArrow";
import styles from "./SectionHeader.module.scss";

export interface SectionHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  headerLinkUrl?: string;
  headerLinkText?: string;
  headerButton?: ReactNode;
  headerSelect?: ReactNode;
  headerToggle?: ReactNode;
  headerSearch?: ReactNode;
  disabled?: boolean;
  hr?: boolean;
  sticky?: boolean;
  dataTestId?: string;
}

export default function SectionHeader({
  title,
  subtitle,
  headerLinkText,
  headerLinkUrl,
  headerButton,
  headerSelect,
  headerToggle,
  headerSearch,
  disabled,
  hr,
  sticky,
  dataTestId,
}: SectionHeaderProps) {
  return (
    <div className={cx(styles.wrapper, sticky && styles.sticky)} data-testid={dataTestId}>
      <div className="container">
        <div className="header-left">
          <div className="header-title">{title}</div>
          {headerSearch && (
            <div className={cx(styles.headerSearchWrapper, !title && styles.noTitle)}>{headerSearch}</div>
          )}
          {subtitle && (
            <>
              <span className={styles.divider} />
              <div className="header-subtitle">{subtitle}</div>
            </>
          )}
        </div>
        <SectionHeaderActions headerButton={headerButton} headerToggle={headerToggle} />
        {headerLinkText && headerLinkUrl && !disabled && (
          <Link href={headerLinkUrl} className={styles.headerLink}>
            {headerLinkText}
            <IconLineArrow size={14} />
          </Link>
        )}
        {headerSelect && <div>{headerSelect}</div>}
      </div>
      {hr && <HorizontalRule style={{ marginTop: "8px", backgroundColor: colors.stoneLightX1 }} />}
    </div>
  );
}

function SectionHeaderActions({
  headerButton,
  headerToggle,
}: Pick<SectionHeaderProps, "headerButton" | "headerToggle">) {
  const actions: ReactNode[] = [];

  if (headerButton) {
    actions.push({ ...(headerButton as ReactElement), key: "0" });
  }

  if (headerToggle) {
    actions.push({ ...(headerToggle as ReactElement), key: "1" });
  }

  return <div className={styles.buttonAndToggleWrapper}>{actions}</div>;
}
